module.exports = __webpack_public_path__ + "media/images/gifts/cook/sug_cozinhar_2-8720cf6fa8c6d9c54736f5c536dfdbe2.jpg";